import * as _ from 'lodash';
import { IComparisonVolume } from '@nkr/models/index';

interface IProps {
    report: IComparisonVolume[]
}

const FooterRow = (props: IProps) => {
    let monthsAgo11 = _.sumBy(props.report, item => item.monthsAgo11);
    let monthsAgo10 = _.sumBy(props.report, item => item.monthsAgo10);
    let monthsAgo9 = _.sumBy(props.report, item => item.monthsAgo9);
    let monthsAgo8 = _.sumBy(props.report, item => item.monthsAgo8);
    let monthsAgo7 = _.sumBy(props.report, item => item.monthsAgo7);
    let monthsAgo6 = _.sumBy(props.report, item => item.monthsAgo6);
    let monthsAgo5 = _.sumBy(props.report, item => item.monthsAgo5);
    let monthsAgo4 = _.sumBy(props.report, item => item.monthsAgo4);
    let monthsAgo3 = _.sumBy(props.report, item => item.monthsAgo3);
    let monthsAgo2 = _.sumBy(props.report, item => item.monthsAgo2);
    let lastMonth = _.sumBy(props.report, item => item.lastMonth);
    let thisMonth = _.sumBy(props.report, item => item.thisMonth);
    let total = _.sumBy(props.report, item => item.total);

    return (
        <tr>
            <td></td>
            <td></td>
            <td>{monthsAgo11}</td>
            <td>{monthsAgo10}</td>
            <td>{monthsAgo9}</td>
            <td>{monthsAgo8}</td>
            <td>{monthsAgo7}</td>
            <td>{monthsAgo6}</td>
            <td>{monthsAgo5}</td>
            <td>{monthsAgo4}</td>
            <td>{monthsAgo3}</td>
            <td>{monthsAgo2}</td>
            <td>{lastMonth}</td>
            <td>{thisMonth}</td>
            <td>{total}</td>
        </tr>
    );
}

export default FooterRow;